import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    shzztoken: '',
    shzzuser: '',
    admintoken: '',
    adminuser: ''
  },
  mutations: {
    increment() {
      // 变更状态
      window.localStorage.setItem('shzztoken', '')
      window.localStorage.setItem('shzzuser', '')
      window.localStorage.setItem('admintoken', '')
      window.localStorage.setItem('adminuser', '')
    },
  }, actions: {
    LogOut(context) {
      context.commit('increment')
    },
  }, modules: {}
})
